/*! Generate ID - v1.0.3 - 2014-09-18
* https://github.com/bboyle/Generate-ID
* Copyright (c) 2014 Ben Boyle; Licensed MIT */
!function(a){"use strict";a.fn.generateId=function(b){var c=1;return b=b?a.trim(b.toLowerCase().replace(/[^a-z0-9_]+/g," ")).replace(/\s+/g,"-"):"id",this.each(function(){var a;if(!this.getAttribute("id")){for(a=b;document.getElementById(a);)a=b+String(c),c++;this.setAttribute("id",a)}})}}(jQuery);


//////////////////
// WEBPACK FOOTER
// ./~/generate-id/dist/generate-id.min.js
// module id = 3
// module chunks = 0